import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  BusinessMaintenance, MaintenanceChannel, MaintenanceNotice, MaintenanceOverview, MaintenanceRequest
} from '../models/maintenance.model';

/**
 * Maintenance mode (specs/maintenance), on the account API's api/admin/maintenance. SuperAdmin only there; the portal
 * shows the page and the business profile's panel to holders of Platform.Maintenance.Manage.
 */
@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private readonly baseUrl = environment.subscriptionApiUrl + '/api/admin/maintenance';

  constructor(private http: HttpClient) {}

  overview(): Observable<MaintenanceOverview> {
    return this.http.get<MaintenanceOverview>(this.baseUrl);
  }

  setPlatform(channel: MaintenanceChannel, request: MaintenanceRequest): Observable<MaintenanceNotice> {
    return this.http.put<MaintenanceNotice>(`${this.baseUrl}/platform/${channel}`, request);
  }

  clearPlatform(channel: MaintenanceChannel): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/platform/${channel}`);
  }

  /** The business's maintenance, or null (the API answers 204) when it is open. */
  getBusiness(businessId: string): Observable<BusinessMaintenance | null> {
    return this.http.get<BusinessMaintenance | null>(`${this.baseUrl}/businesses/${encodeURIComponent(businessId)}`);
  }

  setBusiness(businessId: string, request: MaintenanceRequest): Observable<BusinessMaintenance> {
    return this.http.put<BusinessMaintenance>(`${this.baseUrl}/businesses/${encodeURIComponent(businessId)}`, request);
  }

  clearBusiness(businessId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/businesses/${encodeURIComponent(businessId)}`);
  }
}
